import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { EnterlotpasswordPage } from 'src/app/pages/enterlotpassword/enterlotpassword.page';
import { DataService } from 'src/app/services/data.service';
import { DisclaimersService } from 'src/app/services/disclaimers.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LanguageService } from 'src/app/services/language.service';
import { LoaderService } from 'src/app/services/loader.service';
import { PermitsService } from 'src/app/services/permits.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-waiting-list',
  templateUrl: './waiting-list.page.html',
  styleUrls: ['./waiting-list.page.scss'],
})
export class WaitingListPage {
  loaded = false;
  @Input() lotNameId: any;
  @Input() isModal: any;
  permit: any = {};
  errors = {
    LOT_NOT_AVAILABLE: 'lot-not-available',
    SOLD_OUT: 'sold-out',
    LOT_NOT_VISIBLE: 'lot-not-visible',
    ALREADY_HAS_PERMIT: 'You already have a permit in this lot.',
    LOT_TYPE_NOT_AVAILABLE: 'temp-lot-type-not-available',
    INVALID_DATE_SELECTION: 'temp-invalid-date-selection',
    ALREADY_ON_WAITING_LIST: 'Already on wait list.',
  };
  constructor(
    private errorHandlerSRV: ErrorHandlerService,
    public disclaimerSRV: DisclaimersService,
    private toasterSRV: ToastService,
    private modalCtrl: ModalController,
    private loaderSRV: LoaderService,
    public permitsSRV: PermitsService,
    private route: ActivatedRoute,
    public dataService: DataService,
    private router: Router,
    public translateService: TranslateService,
  ) {
    this.permitsSRV.permit.next({})
  }
  closeModal() {
    if (this.isModal) {
      this.modalCtrl.dismiss();
    } else {
      this.router.navigateByUrl('permits')
    }
  }
  proceed() {

    let url = `permits/standard/reservation/${this.lotNameId}?waitlist=1`;
    this.dataService.getData(url).subscribe({
      next: async (v: any) => {
        if (v?.error_code == 2028) {
          const modal = await this.modalCtrl.create({
            component: EnterlotpasswordPage, // Component for entering the password
            componentProps: {
              LotNameID: this.lotNameId,
              permitType: "standard"
            },
          });

          await modal.present();
          const { data } = await modal.onDidDismiss();
          if (data && data.passwordEntered) {
            this.ionViewWillEnter()

          } else {
            this.closeModal()
          }
        }
        this.permitsSRV.permit.next(v)
        this.loaded = true;

      },
      error: (error) => {
        this.permitsSRV.permit.next(error)
        this.loaded = true;
      }
    })
  }
  async ionViewWillEnter() {


    if (!this.isModal) {
      this.lotNameId = this.route.snapshot.paramMap.get('id');


    }
    var disclaimer;
    disclaimer = this.disclaimerSRV.disclaimers.find(disclaimer => disclaimer['data_trigger'] == 'waitlist-loaded' && disclaimer['locale'] == this.dataService.selected)

    if (disclaimer && disclaimer['active']) {

      this.dataService.createAndOpenModal(disclaimer).then(data => {
        if (data) {
          this.proceed()
        }

      })

    } else {

      this.proceed()


    }

  }
  joinWaitingList() {
    this.loaderSRV.showLoader(this.translateService.instant('keys.data.permits.joining_waiting_list') || 'Joining waiting list...')
    const url = `permits/waitlist/reservation/${this.lotNameId}`;
    this.dataService.postData(url, {}).subscribe({
      next: v => {
        this.loaderSRV.dismissLoader()
        this.modalCtrl.dismiss()
        this.toasterSRV.presentToast(this.translateService.instant('keys.data.permits.joined_waiting_list') || 'Joined waiting list successfully')
      },
      error: err => {
        this.errorHandlerSRV.displayErrorMessage(err, true)

      }
    });
  }
}
